





































import {
  ref, toRefs,
} from 'vue-demi';
import { Anchor, AnimationType } from '@/utils/types.ts';
import { ANIMATION_TYPES } from '@/utils/constant';
import { debouncedWatch } from '@vueuse/core';
import SvgIcon from './SvgIcon.vue';

export default {
  name: 'Prop',
  components: {
    SvgIcon,
  },
  props: {
    animation: {
      type: Object,
      default: () => ({}),
    },
    time: {
      type: Number,
      default: 0,
    },
  },
  setup(props: any, { emit }: any) {
    const { animation, time } = toRefs(props);
    const animationProp: any = ref(ANIMATION_TYPES.find((animationType) => animationType.prop === animation.value.prop));

    const value = ref(animationProp ? animationProp.value.value : 0);

    const isActive = (prop: string) => animation.value.find((type: AnimationType) => type.prop === prop);

    const isAnchorActive = (anchors: Anchor[]) => anchors.some((anchor: Anchor) => anchor.time === time.value);

    const handleInput = (event: any) => {
      const index = animation.value.anchors.findIndex((anchor: Anchor) => +anchor.time === +time.value);
      if (index !== -1) {
        const anchor: Anchor = animation.value.anchors[index];
        animation.value.anchors.splice(index, 1, { ...anchor, value: +event.target.value });
      }
      emit('update');
    };

    const handleCurve = () => {
      console.log('curve');
    };

    const handleLeft = () => {
      const { anchors } = animation.value;
      if (anchors.length === 0) return;
      const minAnchorTime = anchors[0].time;
      if (minAnchorTime >= time.value) {
        return;
      }
      const lastAnchor = anchors[anchors.length - 1];
      if (lastAnchor.time < time.value) {
        emit('timeUpdate', lastAnchor.time);
        return;
      }

      for (const index in anchors) {
        if (anchors[index].time >= time.value) {
          const preAnchor = anchors[+index - 1];
          !!preAnchor && emit('timeUpdate', preAnchor.time);
          break;
        }
      }
    };

    const handleAnchor = () => {
      const { anchors } = animation.value;
      const index = anchors.findIndex((anchor: Anchor) => anchor.time === time.value);
      if (index === -1) {
        anchors.push({ time: time.value, value: value.value });
        anchors.sort((anchorA: Anchor, anchorB: Anchor) => anchorA.time - anchorB.time);
      } else {
        anchors.splice(index, 1);
      }
      emit('update');
    };

    const handleRight = () => {
      const { anchors } = animation.value;
      if (anchors.length === 0) return;
      const maxAnchorTime = anchors[anchors.length - 1].time;
      if (maxAnchorTime <= time.value) {
        return;
      }

      for (const index in anchors) {
        if (anchors[index].time === time.value) {
          const nextAnchor = anchors[+index + 1];
          !!nextAnchor && emit('timeUpdate', nextAnchor.time);
          break;
        }

        if (anchors[index].time > time.value) {
          emit('timeUpdate', anchors[index].time);
          break;
        }
      }
    };

    debouncedWatch(time, (newTime: number) => {
      if (animation.value.anchors.length) {
        const anchor = animation.value.anchors.find((item: any) => item.time === newTime);
        if (anchor) {
          value.value = anchor.value;
        }
      }
    }, { debounce: 100 });

    return {
      value,
      animationProp,
      isActive,
      isAnchorActive,
      handleInput,
      handleCurve,
      handleLeft,
      handleAnchor,
      handleRight,
    };
  },
};
